<template>
    <div class="card is-shadowless">
        <div class="card-header is-shadowless">
            <h3 class="card-header-title">
                Los más buscados
            </h3>
            <p v-show="false">Ranking de pks, los pkers más poderosos del juego.</p>
        </div>
        <div class="card-content is-paddingless">
            <table class="table is-hoverable is-fullwidth" v-if="rankingItems.length > 0">
                <thead>
                    <tr class="has-text-justified">
                    <th>Pos.</th>
                    <th>Nombre</th>
                    <th>Kills</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rank, n) in rankingItems" :key="n" class="has-text-justified">
                    <td>
                        <fa icon="skull" :class="{'blood-color':n==0,'has-text-dark':n==1,'has-text-grey-light':n==2}" />
                    </td>
                    <td><fa icon="heartbeat" class="has-text-primary heart-beat" v-if="rank.is_online" v-tooltip="{ content: 'En Línea' }" /><fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else /> {{rank.name}}</td>
                    <td>{{rank.pkcount}}</td>
                    </tr>
                </tbody>
            </table>
            <p v-else>Próximamente...</p>
        </div>
        <div class="card-footer">
            <router-link to="/ranking/asesinos" class="card-footer-item has-text-danger-dark">Ver más</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name:'HomeRankingSection',
    computed: {
        api() {
            return this.$store.getters.GetApiPath
        },
        rankingItems() {
            return this.$store.getters.GetTop3Pker
        }
    }
}
</script>

<style>

</style>